import { createProject, editProjectProject } from "@/services/createSpace/project";
import {
  Button,
  Input,
  Message,
  Space,
  Tree,
} from "@arco-design/web-react";
import { IconCheck, IconClose, IconEdit, IconPlus } from "@arco-design/web-react/icon";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { debounce } from "lodash"

export default function Index({ value, onChange, createFolder, renameFolder, useHook}: any) {
  const [expandedKeys, setExpandedKeys] = useState([])
  const isEdit = useRef(false)
  const inputRef = useRef(null)
  const [visible, setVisible] = useState(false)
  // const [treeData, setTreeData] = useState(TreeData);
  const { treeData, setTreeData, init } = useHook();
  const [projectVisible, setProjectVisible] = useState(false);
  const [projectValue, setProjectValue] = useState("");
  const [inputValue, setInputValue] = useState(""); // 新增状态用于存储Input的值
  const handleCreateProject = useCallback(
    debounce(() => {
    if (!projectValue) {
      Message.error('请输入项目名称')
      return;
    }
    createProject({ name: projectValue, memberIds: [] }).then(() => {
      Message.success('新建项目成功')
      setProjectValue('')
      setProjectVisible(false)
      init();
    }).catch(e => {
      Message.error(e)
    })
  }, 2000, {leading: true, trailing: false}),
  [projectValue]
  )
  const [folderValue, setFolderValue] = useState("");
  // 查找父节点
  const findParentNodes = (data, key, parents = []) => {
    for (const node of data) {
      if (node.key === key) {
        return parents;
      }
      if (node.children) {
        const found = findParentNodes(node.children, key, [...parents, node]);
        if (found) return found;
      }
    }
    return null;
  };
  const onSelect = (value, extra) => {
    if (extra.node.props.dataRef?.type === 'new-input' || extra.node.props.dataRef?.type === 'edit-input') {
      return;
    }
    console.log(extra.node.props.dataRef)
    console.log(value, extra)
    // 找到选中节点的title
    const parents = findParentNodes(treeData, extra.node.props.dataRef.key)
    let str = ''
    if(extra.node.props.dataRef?.title) {
      const title = extra.node.props.dataRef?.title
      parents.forEach((item, index) => {
        str = str + `${index !== 0 ? '/' : ''}${item.title}`
      })
      if (extra.node.props.dataRef?.type === 'project') {
        str = str + `${title}`
      } else {
        str = str + `/${title}`
      }
      setInputValue(str); // 设置Input的值为选中节点的title
      setVisible(false); // 选择后关闭下拉菜单
    }
    if (extra.node.props.dataRef?.type === 'project') {
      const [projectId] = extra.node.props.dataRef?.key?.split(':') || "0:0"
      const parentId = 0
      onChange({
        projectId: Number(projectId),
        parentId,
        pathName: str,
      })
    }
    if (extra.node.props.dataRef?.type === 'folder') {
      const [projectId, parentId] = extra.node.props.dataRef?.key?.split(':') || "0:0"
      onChange({
        projectId: Number(projectId),
        parentId: Number(parentId),
        pathName: str,
      })
    }
  }
  const handleCreateFolder = useCallback(
    debounce((parentNode) => {
    if (!folderValue) {
      Message.error('请输入文件夹名称')
    }
    let path = ''
    let project_id = 0
    const [l] = parentNode.key.split(':')
    if (parentNode.type === 'project') {
      path = folderValue
      project_id = Number(l)
    }
    if (parentNode.type === 'folder') {
      path = parentNode.title + '/' + folderValue
      project_id = Number(l)
    }
    console.log(project_id, 'project_id')
    createFolder({
      path: path,
      project_id: Number(project_id),
      projectId: Number(project_id),
    }).then(() => {
      Message.success('新建文件夹成功')
      isEdit.current = false;
      setFolderValue('')
      init();
    }).catch(e => {
      Message.error(e)
    })
  }, 2000, {leading: true, trailing: false}),
  [folderValue]
  )
  const handleCancelProject = () => {
    setProjectValue('');
    setProjectVisible(false);
  }
  const handleCancel = () => {
    const cloneData = JSON.parse(JSON.stringify(treeData))
    const removeNodeByKey = (treeData, keyToRemove) => {
      // 递归遍历树
      function traverse(nodes) {
        return nodes.filter(node => {
          if (node.type === keyToRemove) {
            return false; // 过滤掉匹配的节点
          }
          
          if (node.children) {
            node.children = traverse(node.children); // 递归处理子节点
          }
          
          return true;
        });
      }  
      return traverse(treeData);
    }
    const newTreeData = removeNodeByKey(cloneData, 'new-input');
    isEdit.current = false;
    setFolderValue('')
    setTreeData(newTreeData);
  }
  const [editValue, setEditValue] = useState('')
  const oldType = useRef('')
  const handleEdit = useCallback(
    debounce((item) => {
    if (oldType.current === 'folder') {
      console.log('修改文件夹')
      const [_, id] = item.key.split(":")
      renameFolder(id, editValue).then(() => {
        Message.success('修改文件夹成功')
        isEdit.current = false
        setEditValue('')
        init()
      }).catch(e => {
        Message.error(e)
      })
    } else if (oldType.current === 'project') {
      console.log('修改项目')
      const [id] = item.key.split(":")
      editProjectProject({name: editValue, id: Number(id)}).then(() => {
        Message.success('修改项目成功')
        isEdit.current = false
        setEditValue('')
        init()
      }).catch(e => {
        Message.error(e)
      })
    }
    console.log(item)
  }, 2000, {leading: true, trailing: false}),
    [editValue]
  );
  const generatorTreeNodes = (treeData1, parentNode) => {
    return treeData1.map((item) => {
      const { children, key, title, ...rest } = item;
      return (
        <Tree.Node
          key={key}
          title={
            item.type === "new-input" ? (
              <div>
                <Space>
                  <Input
                    onPressEnter={() => handleCreateFolder(parentNode)}
                    value={folderValue}
                    onChange={(value) => {
                      setFolderValue(value);
                    }}
                    placeholder="请输入文件夹名称"
                  />
                  <div>
                    <IconCheck onClick={() => handleCreateFolder(parentNode)} />
                    <IconClose style={{ marginLeft: '10px' }} onClick={handleCancel}/>
                  </div>
                </Space>
              </div>
            ) : (
              item.type === 'edit-input' ? (
                <Space>
                  <Input
                    value={editValue}
                    onPressEnter={() => handleEdit(item)}
                    onChange={(value) => {
                      setEditValue(value);
                    }}
                    placeholder="请输入文件夹名称"
                  />
                  <div>
                    <IconCheck onClick={() => handleEdit(item)} />
                    <IconClose style={{ marginLeft: '5px' }} onClick={(e) => {
                      e.stopPropagation()
                      isEdit.current = false
                      item.type = oldType.current
                      setTreeData([...treeData])
                    }}/>
                  </div>
                </Space>
              ) : (
                title
              )
            )
          }
          {...rest}
          dataRef={item}
        >
          {children ? generatorTreeNodes(item.children, item) : null}
        </Tree.Node>
      );
    });
  };
  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    // 检查点击是否发生在下拉菜单和按钮外部
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setVisible(false);
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const onExpand = (expandedKeys) => {
    console.log(expandedKeys)
    setExpandedKeys(expandedKeys);
  }
  const onFocus = useCallback((e) => {
    setVisible(true);
  }, [visible])
  return (
      <div style={{ position: "relative" }} ref={dropdownRef}>
        <Input
        ref={inputRef}
        placeholder="请选择..."
        value={inputValue} // 使用inputValue作为Input的值
        onClick={onFocus}>
        </Input>
        <div
        style={{ 
          padding: "10px", position: "absolute", top: 40, left: '0px', right: '0px', background: '#fff', zIndex: 300,
          display: visible ? 'block' : 'none'
          }}>
          <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
            <Tree
            expandedKeys={expandedKeys}
            onExpand={onExpand}
            onSelect={onSelect}
            renderExtra={(node: any) => {
              return (node?.type !== "new-input" ) ? (
                <div>
                  {(node?.level !== 3) && <IconPlus
                    style={{
                      position: "absolute",
                      right: 8,
                      fontSize: 12,
                      top: 10,
                      color: "#3370ff",
                    }}
                    onClick={() => {
                      if (isEdit.current) {
                        Message.error('已有新建或者编辑，请完成当前操作')
                        return;
                      }
                      const keys = [...new Set([...expandedKeys, node._key])]
                      isEdit.current = true;
                      const dataChildren = node.dataRef.children || [];
                      dataChildren.push({
                        title: "new tree node",
                        key: node._key + "-" + (dataChildren.length + 1),
                        type: "new-input",
                      });
                      node.dataRef.children = dataChildren;
                      setTreeData([...treeData]);
                      setExpandedKeys(keys)
                    }}
                  />}
                <IconEdit onClick={() => {
                  if (isEdit.current) {
                    Message.error('已有新建或者编辑，请完成当前操作')
                    return;
                  }
                  isEdit.current = true;
                  oldType.current = node.dataRef.type
                  node.dataRef.type="edit-input"
                  setEditValue(node.dataRef.title)
                  setTreeData([...treeData]);
                }} style={{
                    position: "absolute",
                    right: 28,
                    fontSize: 12,
                    top: 10,
                    color: "#3370ff",
                  }}></IconEdit>
                </div>
              ) : null;
            }}
          >
            {generatorTreeNodes(treeData, {})}
          </Tree>
          </div>
          <div>
            {projectVisible ? (
              <Space>
                <Input
                  onPressEnter={handleCreateProject}
                  value={projectValue}
                  onChange={(value) => {
                    setProjectValue(value);
                  }}
                  placeholder="请输入项目名称"
                />
                <Space>
                  <Button
                    size="small"
                    type="primary"
                    onClick={handleCreateProject}
                  >
                    确定
                  </Button>
                  <Button size="small" type="text" onClick={handleCancelProject}>
                    取消
                  </Button>
                </Space>
              </Space>
            ) : (
              <Button
                size="small"
                type="outline"
                onClick={() => {
                  setProjectVisible(true);
                }}
              >
                新增项目
              </Button>
            )}
          </div>
        </div>
      </div>
  );
}
